import { render, staticRenderFns } from "./CanteenAlert.vue?vue&type=template&id=338d1b71&lang=pug&"
import script from "./CanteenAlert.vue?vue&type=script&lang=js&"
export * from "./CanteenAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports